<div class="dialog-header">
  <h2 fxLayoutAlign="center center" mat-dialog-title cdkFocusInitial tabindex="-1">Otopark Bilgisi</h2>
  <button class="close-button" [matTooltip]="'shared.labels.close'|translate" [mat-dialog-close]="false" mat-icon-button>
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content class="parking-modal-content">
  <p class="parking-info-text">{{ data?.parkingInfo || 'Bu mekan için otopark bilgisi bulunmamaktadır.' }}</p>
</mat-dialog-content>
